"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _Button = _interopRequireDefault(require("../Button/Button.styles"));
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useStyles = props => {
  const {
    fontFamily,
    themeColors
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const {
    isBtnView = false,
    color = 'primary',
    customStyle = {}
  } = props;
  const buttonStyles = (0, _Button.default)(props);
  const ccAStyle = (0, _react.useMemo)(() => {
    const colorProps = () => {
      const textColor = color === 'primary' ? themeColors?.primary.main : themeColors?.general.text;
      return {
        color: textColor
      };
    };
    const ccA = (0, _css.css)({
      fontFamily: fontFamily,
      cursor: 'pointer',
      textDecoration: 'none',
      fontSize: 'inherit',
      ...colorProps(),
      ...customStyle,
      '&:hover, &:focus': {
        textDecoration: 'underline'
      },
      '&[data-disabled=true]': {
        opacity: '0.5',
        cursor: 'default',
        pointerEvents: 'none'
      }
    });
    return ccA;
  }, [fontFamily, customStyle, color, themeColors?.primary.main, themeColors?.general.text]);
  const ccLinkBtn = buttonStyles['cc-Button'];
  return {
    'cc-A': isBtnView ? ccLinkBtn : ccAStyle
  };
};
exports.useStyles = useStyles;
var _default = exports.default = useStyles;